/**
 * Options for encoding a structured field.
 *
 * @group Structured Field
 *
 * @beta
 */
export type SfEncodeOptions = {
	/**
	 * Include whitespace in the output.
	 */
	whitespace?: boolean;
};
